import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AppPrefsProvider } from './AppPrefs';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppPrefsProvider>
      <App />
    </AppPrefsProvider>
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      console.log('SW registered: ', registration.scope);
    }).catch(error => {
      console.log('SW registration failed: ', error);
    });
  });
}
